import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material';

function ApiErrorMessage({ openApiError, setOpenApiError, errorMessage, path }) {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpenApiError(false);
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box>
      <Dialog
        open={openApiError}
        onClose={(e) => setOpenApiError(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{errorMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
export default ApiErrorMessage;
